module.exports = {"Main":["Home","Home2","Presto","Project","SFP"],"Mobile":["MobileHome","MobileHome2","MobilePresto","MobileProject","MobileSFP"]}


//////////////////
// WEBPACK FOOTER
// ./screens.json
// module id = 34
// module chunks = 0